export const CLOUDPAT_OBSERVATION_SYSTEM = 'https://cloudpat.itamar-medical.com/observation-type';

export const STUDY_XML_CLINICAL_FIELDS: Record<string, string> = {
  TotalSleepTime: 'Total Sleep Time',
  TotalAH_CentralValidSleepTime: 'Technically Valid Sleep Time',
  AHI: 'AHI',
  AHICentral: 'Central AHI',
  MeanPRSleep: 'Mean Pulse Rate During Sleep',
  MinPRSleep: 'Min Pulse Rate During Sleep',
  MaxPRSleep: 'Max Pulse Rate During Sleep',
  Supine_AHI: 'Supine AHI',
  NonSupine_AHI: 'Non-Supine AHI',
  SatBelowEqual88: 'Time SpO2 ≤88%',
  MeanNadirDesaturations: 'Mean Nadir of Desaturations',
};

export const UCUM_UNIT_CODES: Record<string, string> = {
  secs: 's',
  db: 'dB',
  '%min': '%.min',
};

export const COMPOSITION_TYPE_HSAT_INTAKE = 'hsat-intake';
export const COMPOSITION_TYPE_SELF_REFERRAL_INTAKE = 'self-referral-intake';
export const COMPOSITION_TYPE_PCP_REFERRAL_INTAKE = 'pcp-referral-intake';

export const TRIAGE_COMPOSITION_TYPES = [
  COMPOSITION_TYPE_SELF_REFERRAL_INTAKE,
  COMPOSITION_TYPE_PCP_REFERRAL_INTAKE,
] as const;
